import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {LoginResponesModel} from 'models/auth';
import {AppRootState} from '../appStore';
import {SettingsKeyValueResponseModel} from 'models/settings';
export interface SessionStateType extends LoginResponesModel {}
const initialState: SessionStateType = {
    sessionId: '',
    jwtToken: '',
    expirey: 0,
    userId: '',
    tenantId: '',
    refreshToken: '',
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    tenantName: '',
    workspaceSlug: '',
    boardSlug: '',
    tenantSlug: '',
    tenantSettings: [],
    workspaceSettings: [],
    boardSettings: [],
};
export interface UpdateTenantInRedux {
    tanentId: string;
    tanentSlug: string;
}
export const SessionSlice = createSlice({
    name: 'session',
    initialState: initialState,
    reducers: {
        setSession: (state, action: PayloadAction<LoginResponesModel>) => {
            state.sessionId = action.payload.sessionId;
            state.jwtToken = action.payload.jwtToken;
            state.expirey = action.payload.expirey;
            state.userId = action.payload.userId;
            state.tenantId = action.payload.tenantId;
            state.refreshToken = action.payload.refreshToken;
            state.email = action.payload.email;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.phoneNumber = action.payload.phoneNumber;
            state.tenantName = action.payload.tenantName;
            state.workspaceSlug = action.payload.workspaceSlug;
            state.boardSlug = action.payload.boardSlug;
            state.tenantSlug = action.payload.tenantSlug;
            state.tenantSettings = action.payload.tenantSettings;
            state.workspaceSettings = action.payload.workspaceSettings;
            state.boardSettings = action.payload.boardSettings;
        },

        clearSession: state => {
            state.sessionId = '';
            state.jwtToken = '';
            state.expirey = 0;
            state.userId = '';
            state.tenantId = '';
            state.refreshToken = '';
            state.email = '';
            state.firstName = '';
            state.lastName = '';
            state.phoneNumber = '';
            state.tenantName = '';
            state.workspaceSlug = '';
            state.boardSlug = '';
            state.tenantSlug = '';
            state.tenantSettings = [];
            state.workspaceSettings = [];
            state.boardSettings = [];
        },
        updateTenatInRedux(state, action: PayloadAction<UpdateTenantInRedux>) {
            if (state.tenantId !== action.payload.tanentId) {
                state.tenantId = action.payload.tanentId;
                state.tenantSlug = action.payload.tanentSlug;
            }
        },
        updateTenatSettingsRedux(state, action: PayloadAction<SettingsKeyValueResponseModel[]>) {
            state.tenantSettings = action.payload;
        },
    },
});

export const {clearSession, setSession, updateTenatInRedux, updateTenatSettingsRedux} = SessionSlice.actions;

export const sessionSliceReducer = SessionSlice.reducer;
export const sessionSelector = (rootState: AppRootState): SessionStateType => rootState.session;
